// Initialize product page functionality
document.addEventListener('DOMContentLoaded', function() {
    initCollapsibleSections();
    initQuantitySelectors();
    initVariantSelectors();
    initProductBundle();
    initImageZoom();
  });
  
  // Collapsible sections (Description, Size Guide, Policies)
  function initCollapsibleSections() {
    const collapsibleTriggers = document.querySelectorAll('.collapsible-section.is-collapsible .collapsible-trigger');
    
    collapsibleTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const section = this.closest('.collapsible-section');
        const content = section.querySelector('.collapsible-content');
        const icon = this.querySelector('.collapsible-icon');
        
        section.classList.toggle('expanded');
        
        if (section.classList.contains('expanded')) {
          content.style.maxHeight = content.scrollHeight + 'px';
          if (icon) icon.textContent = '▲';
        } else {
          content.style.maxHeight = '0px';
          if (icon) icon.textContent = '▼';
        }
      });
    });
    
    // Initially hide all collapsible content
    document.querySelectorAll('.collapsible-section.is-collapsible .collapsible-content').forEach(content => {
      content.style.maxHeight = '0px';
    });
  }
  
  // Quantity selectors
  function initQuantitySelectors() {
    const quantityDown = document.querySelectorAll('.quantity-down');
    const quantityUp = document.querySelectorAll('.quantity-up');
    
    quantityDown.forEach(button => {
      button.addEventListener('click', function() {
        const input = document.querySelector(this.dataset.quantityInput);
        let value = parseInt(input.value);
        
        if (value > 1) {
          input.value = value - 1;
        }
      });
    });
    
    quantityUp.forEach(button => {
      button.addEventListener('click', function() {
        const input = document.querySelector(this.dataset.quantityInput);
        let value = parseInt(input.value);
        
        input.value = value + 1;
      });
    });
  }
  
  // Variant selectors
  function initVariantSelectors() {
    const optionValues = document.querySelectorAll('.option-value');
    const variantSelect = document.querySelector('.product-single__variants');
    
    if (!optionValues.length || !variantSelect) return;
    
    optionValues.forEach(option => {
      option.addEventListener('click', function() {
        // Remove selected class from all options in this group
        const allOptions = document.querySelectorAll(`[data-index="${this.dataset.index}"]`);
        allOptions.forEach(opt => opt.classList.remove('selected'));
        
        // Add selected class to clicked option
        this.classList.add('selected');
        
        // Update hidden select
        updateVariantSelect();
      });
    });
    
    function updateVariantSelect() {
      const selectedOptions = [];
      
      // Get all selected options
      document.querySelectorAll('.option-value.selected').forEach(selected => {
        const index = selected.dataset.index;
        const value = selected.dataset.value;
        selectedOptions.push({ index, value });
      });
      
      // Find matching variant
      if (selectedOptions.length === document.querySelectorAll('.option-selector').length) {
        for (let i = 0; i < variantSelect.options.length; i++) {
          const option = variantSelect.options[i];
          const variantTitle = option.text.split(' - ')[0]; // Remove price part
          
          let allMatch = true;
          for (const selected of selectedOptions) {
            const optionPosition = parseInt(selected.index.replace('option', ''));
            const optionIndex = optionPosition - 1;
            const optionValue = selected.value;
            
            // Split variant title to get option values
            const variantOptions = variantTitle.split(' / ');
            
            if (variantOptions[optionIndex] !== optionValue) {
              allMatch = false;
              break;
            }
          }
          
          if (allMatch) {
            variantSelect.value = option.value;
            break;
          }
        }
      }
    }
  }
  
  // Product bundle functionality
  function initProductBundle() {
    const addToBundle = document.querySelector('.add-to-bundle-button');
    
    if (addToBundle) {
      addToBundle.addEventListener('click', function() {
        // This would open a modal or implement your bundle product selection logic
        console.log('Add to bundle clicked');
      });
    }
  }
  
  // Image zoom functionality
  function initImageZoom() {
    const zoomableImages = document.querySelectorAll('.image-zoom');
    
    zoomableImages.forEach(image => {
      image.addEventListener('mousemove', function(e) {
        const { left, top, width, height } = this.getBoundingClientRect();
        const x = (e.clientX - left) / width * 100;
        const y = (e.clientY - top) / height * 100;
        
        this.style.transformOrigin = `${x}% ${y}%`;
      });
      
      image.addEventListener('mouseenter', function() {
        this.style.transform = 'scale(1.5)';
      });
      
      image.addEventListener('mouseleave', function() {
        this.style.transform = 'scale(1)';
      });
    });
  }